// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--IB7JD","title":"a10a3f92e9--title--C9rer","subtitle":"a10a3f92e9--subtitle--Zs0om"};